const overrideFormLabel = (theme) => {
  theme.overrides.MuiAutocomplete = {
    popupIndicator: {
      marginRight: theme.spacing(2)
    }
  };
};

export default overrideFormLabel;
